/* eslint-disable */
import React, { Component } from 'react';
import { messages } from '../../common/messages';
import SaveQuestion from '../QuestionBank/SaveQuestion';
import ReportQuestion from '../QuestionBank/ReportQuestion';
import { showInformation } from '../../common/toast';

export default class VideoValidateReportsIcons extends Component {
  static contextTypes = { router: React.PropTypes.object };

  constructor(props) {
    super(props);
    this.state = {};
  }
  onHandleDownloadPDF = () => {
    const { currentVideo, isUserSubscribed, toggleAlert } = this.props;
    if (isUserSubscribed) {
      if (currentVideo.pdf_file) {
        const myWindow = window.open(currentVideo.pdf_file);
        myWindow.focus();
      } else {
        showInformation(messages.PDF_NOT_AVAILABLE);
      }
    } else {
      toggleAlert();
    }
  };
  render() {
    const { router } = this.context;
    const {
      isMoveToNotesIcon = true,
      isMoveToQuestionIcon = true,
      notesRedirectRoute = '',
      questionRedirectRoute = '',
      savePayLoad,
      favItemId,
      onSaveItemChange,
      setChildRef,
      apiServiceProvider,
      toggleReportSection,
      isUserSubscribed = false,
    } = this.props;

    return (
      <div className='row'>
        <div className='col-sm-12 d-flex mb-2'>
          <span className='d-inline-flex align-items-center'>
            {isMoveToNotesIcon && (
              <span className='up tooltip-hover-questions' style={{ padding: '10px' }}>
                <div className='tootip_box'> {messages.GO_TO_NOTES} </div>
                <i
                  onClick={() => router.push({ pathname: notesRedirectRoute })}
                  className='fa fa-book mark-action-btn'
                  style={{ color: '#1f8ceb' }}
                />
              </span>
            )}
            {isMoveToQuestionIcon && (
              <span className='up tooltip-hover-questions' style={{ padding: '10px' }}>
                <div className='tootip_box'> {messages.GO_TO_QUESTION_BANK} </div>
                <i
                  onClick={() => router.push({ pathname: questionRedirectRoute })}
                  className='fa fa-question-circle-o mark-action-btn'
                  style={{ color: '#1d364b' }}
                />
              </span>
            )}
            <SaveQuestion
              savePayLoad={savePayLoad}
              favItemId={favItemId}
              onSaveItemChange={onSaveItemChange}
              setChildRef={setChildRef}
              apiServiceProvider={apiServiceProvider}
            />
            <ReportQuestion
              onClick={toggleReportSection}
              reportTooltipText={messages.REPORT_THIS_VIDEO}
            />
          </span>
            <div onClick={() => this.onHandleDownloadPDF()} className='status-download-btn ml-auto'>
              <a className='btn btn-primary  pointer_class pull-right'>
                <i className='fa fa-download  ' aria-hidden='true' />
                {!isUserSubscribed && <div className='premium-download'>{messages.PREMIUM}</div>}
                {messages.Download_PDF}
              </a>
            </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/Videos/VideoValidateReportsIcons.jsx